import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { formValueSelector } from 'redux-form';

import { getQueryParams } from '../../../utils/services/queryParams';
import { Grid, GridColumn, ModalTitle, ModalSubtitle } from '../../../core/components/styled';
import { createSuccessNotification, createErrorNotification } from '../../../core/services/createNotification';
import { Modal } from '../../../core/components';
import { LIMIT_PER_PAGE } from '../../constants';
import translate from '../../../core/services/translate';
import { ReportIssueOnCallServicesForm } from '../forms';
import { AppState } from '../../../store';

interface ComponentProps {
  workOrderIdentifier: string;
  workOrder: number;
  vendorId: number;
  action?: number;
  scheduledDate: any;
  updateIssueReportOnCallServices(...args: any[]): any;
  onCancel(...args: any[]): any;
  location: any;
  token: string;
}

type Props = ComponentProps & {
  rateCodes?: any[];
  issueTypeOption?: any;
  issueDescription?: any;
  issueType?: any;
  pricingInfo?: any;
  isSaving?: boolean;
};

class ReportIssueOnCallServicesModal extends PureComponent<Props> {
  onSubmit = async () => {
    const {
      vendorId,
      workOrder,
      scheduledDate,
      issueTypeOption,
      issueDescription,
      //   action,
      //   rateCodes,
      location,
      pricingInfo,
      onCancel,
      token,
    } = this.props;
    const { page } = getQueryParams(location.search);
    const requestRecurringServicesObj: any = {};

    requestRecurringServicesObj.workOrder = workOrder;
    requestRecurringServicesObj.issueType = issueTypeOption;
    requestRecurringServicesObj.issueDescription = issueDescription;
    requestRecurringServicesObj.date = moment(pricingInfo.reportDate).format('YYYY-MM-DD');
    requestRecurringServicesObj.scheduleDate = moment(scheduledDate).format('YYYY-MM-DD');

    await this.props
      .updateIssueReportOnCallServices(requestRecurringServicesObj, vendorId, token, page, LIMIT_PER_PAGE)
      .then(() => {
        createSuccessNotification(translate('opportunity.opportunitySave'));
        onCancel(true);
      })
      .catch(() => {
        createErrorNotification(translate('opportunity.opportunitySaveError'));
      });
  };

  stopPropagation = (event: any) => {
    event.preventDefault();
  };

  render() {
    const { isSaving, onCancel } = this.props;

    return (
      <Modal size="small" isLoading={isSaving}>
        <ModalTitle>{translate('payment.reportIssue')}</ModalTitle>
        <ModalSubtitle />
        <Grid centered>
          <GridColumn size="8/12">
            <ReportIssueOnCallServicesForm {...this.props} onSubmit={this.onSubmit} onCancel={onCancel} />
          </GridColumn>
        </Grid>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('reportIssueOnCallServices');

const mapStateToProps = (state: AppState, ownProps: ComponentProps) => ({
  rateCodes: formSelector(state, `workOrdersInfo.settings${ownProps.workOrderIdentifier}.rateCodes`),
  issueTypeOption: formSelector(state, `workOrdersInfo.settings${ownProps.workOrderIdentifier}.issueType`),
  issueDescription: formSelector(state, `workOrdersInfo.settings${ownProps.workOrderIdentifier}.issueDescription`),
  pricingInfo: state.payments.onCallServices.pricingInfo,
  issueType: state.payments.onCallServices.issueType,
  isSaving: state.payments.onCallServices.isSaving,
});

export default connect(mapStateToProps, undefined)(ReportIssueOnCallServicesModal);
